<template>
  <div class="cart-menu float-right mr-2 mr-sm-3 mr-xl-4">
    <a
      v-if="!$root.isLoggedIn"
      class="header-button clearfix cart-button d-flex"
      :href="route('login')"
    >
      <div class="icon-wrap">
        <div v-if="numItems" class="num">{{numItems}}</div>
        <icon icon="shopping-cart" class="icon" />
        <span class="text">Cart</span>
      </div>
    </a>
    <ContextMenu v-else id="cart-menu-dropdown" :items="menu" align="left">
      <span class="header-button clearfix cart-button d-flex">
        <div class="icon-wrap">
          <div class="num" v-if="numItems">{{numItems}}</div>
          <icon icon="shopping-cart" class="icon" />
        </div>
        <span class="text">Cart</span>
      </span>
    </ContextMenu>
  </div>
</template>

<script>
export default {
  props: {
    numItems: { type: Number, default: 0 },
    cost: { type: String | Number, default: 0.0 },
  },
  computed: {
    menu() {
      return [
        {
          label: `${this.numItems} item(s) in cart`,
          class: "disabled pb-0",
        },
        {
          label: `$${parseFloat(this.cost).toFixed(2)}`,
          class: "disabled font-size-lg pt-0",
        },
        {
          label: `<hr class="m-0 border-white" />`,
          class: "disabled py-0 px-3",
        },
        {
          label: "View Online Cart",
          class: "pt-2",
          action: () => {
            this.goToRoute("enroll.online.cart");
          },
        },
        {
          label: "View Roster Queue",
          class: "pt-2",
          action: () => {
            this.goToRoute("enroll.classroom.cart");
          },
        },
      ];
    },
  },
};
</script>